'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var callApi = exports.callApi = function callApi(url, options) {
  return fetch(url, options).then(function (response) {
    return response.ok ? response.json() : Promise.reject(response.text());
  }, function (error) {
    return Promise.reject(error);
  }).then(function (json) {
    return {
      json: camelize(json)
    };
  }, function (error) {
    return {
      error: error
    };
  }).catch(function (error) {
    return {
      error: error
    };
  });
};

var sendFileToBrowser = exports.sendFileToBrowser = function sendFileToBrowser(response) {
  var contentDisposition = response.headers.get('Content-Disposition');
  var result = contentDisposition && contentDisposition.split(';')[1].trim().split('=')[1];
  var filename = result ? result.replace(/"/g, '') : '';

  if (filename && response.ok) {
    return response.blob().then(function (blob) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // for IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        var url = (window.URL || window.webkitURL).createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link); // Firefox

        link.click();
      }
    });
  }
};